import $ from 'jquery';
import { getBreakpoints } from '../utils/utils';

const body = 'body';
const header = '.header';
const hamburgerButton = '#nav';
const hamburger = '.c-hamburger, .c-hamburger__item';
const nav = '.nav';
const navList = '.nav__list';
const navItem = '.nav__item';
const navLink = '.nav__link';
const navLinkTitle = '.nav__link-title';
const submenuArrow = '.nav__submenu-arrow';
const submenuOuter = '.nav__submenu-outer';
const submenuLink = '.nav__submenu-link';
const submenuBtn = '.nav__submenu-button';
const timeToEffect = 250;
const breakPoint = getBreakpoints().lg;

let width = $(window).width();
let height = $(window).height();

function hamburgerClose() {
  $(hamburger).removeClass('open');
}

function headerOpen() {
  $(header).addClass('open');
}

function headerClose() {
  $(header).removeClass('open');
}

function headerSubmenuOpen() {
  setTimeout(() => {
    $(header).addClass('submenu-opened');
  }, 400);
}

function headerSubmenuClose() {
  setTimeout(() => {
    $(header).removeClass('submenu-opened');
  }, 400);
}

function menuOpen() {
  $(nav).finish().show().animate({ opacity: 1 }, timeToEffect, 'linear', () => {
    $(nav).show().addClass('open');
  });
  $(navList).slideDown().finish();

  if ($(window).width() < breakPoint) {
    $(body).addClass('overflow-hidden');
  } else {
    $(body).removeClass('overflow-hidden').removeAttr('style');
  }
}

function menuClose() {
  $(navList).slideUp().removeAttr('style').finish();
  $(nav).finish().animate({ opacity: 0 }, timeToEffect, 'linear', () => {
    $(nav).hide().removeClass('open').removeAttr('style');
  });
  $(body).removeClass('overflow-hidden').removeAttr('style');

  // Clear the azds booking app's stale scroll-lock classes left when the menu
  // opens over an open overlay; `noscroll` (position: fixed) breaks swiper widths.
  const bookingLayout = document.querySelector('booking-layout.noscroll, app-layout.noscroll');
  if (bookingLayout) {
    bookingLayout.classList.remove('noscroll');
    document.body.classList.remove('azds-overflow-hidden');
    window.dispatchEvent(new Event('resize'));
  }
}

function submenuOpen(event) {
  const closest = $(event.target).closest(navItem);
  const navlink = closest.find(navLink);
  const submenu = closest.find(submenuOuter);
  const submenulinks = submenu.find('a');
  submenulinks.removeAttr('tabindex');
  closest.addClass('open');
  navlink.addClass('open');
  navlink.attr('aria-expanded', 'true');
  headerSubmenuOpen();

  if (!submenu.hasClass('nav__submenu-outer--transition')) {
    submenu.addClass('nav__submenu-outer--transition');
  }

  if ($(window).width() < breakPoint) {
    submenu.addClass('open')
      .show()
      .css({ opacity: 1 });
  }
}

function submenuOpenFirst(event) {
  const current = $(event.target);
  const closest = current.closest(navItem);
  const submenu = closest.find(submenuOuter);
  const navlink = closest.find(navLink);
  navlink.addClass('open');
  headerSubmenuOpen();
  if ($(window).width() < breakPoint) {
    submenu.finish()
      .show()
      .addClass('open')
      .animate({ opacity: '1' }, timeToEffect, 'linear');
  }
}

function closeSubmenuViaClick() {
  $(navLink).removeClass('open');
  $(navItem).removeClass('open');
  $(navLinkTitle).removeClass('open');
  $(submenuArrow).removeClass('open');
  $(submenuOuter).finish()
    .removeClass('open')
    .css({ opacity: 0 })
    .slideUp(timeToEffect);
}

function submenuArrowOpen(event) {
  closeSubmenuViaClick();
  const current = $(event.target);
  const closest = current.closest(navItem);
  const navlink = closest.find(navLink);
  const submenu = closest.find(submenuOuter);
  const submenulinks = submenu.find('a');
  submenulinks.removeAttr('tabindex');
  current.addClass('open');
  navlink.addClass('open');
  closest.addClass('open');
  navlink.attr('aria-expanded', 'true');
  if ($(window).width() < breakPoint) {
    submenu.finish()
      .addClass('open')
      .css({ opacity: 1 })
      .slideDown(timeToEffect);
  }
}

function submenuArrowClose(event) {
  const current = $(event.target);
  const closest = current.closest(navItem);
  $(navLink).attr('aria-expanded', 'false');
  $(navLink).removeClass('open');
  $(current).removeClass('open');
  $(closest).removeClass('open');
  $(navLinkTitle).removeClass('open');
  $(submenuArrow).removeClass('open');
  $(submenuOuter).find('a').attr('tabindex', '-1');

  if ($(window).width() < breakPoint) {
    $(submenuOuter).finish()
      .removeClass('open')
      .css({ opacity: 0 })
      .slideUp(timeToEffect);
  }
}

function submenuClose(event) {
  const current = $(event.target);
  const closest = current.closest(navItem);
  const submenu = closest.find(submenuOuter);
  const submenulinks = submenu.find('a');
  submenulinks.attr('tabindex', '-1');
  const navlink = closest.find(navLink);
  closest.removeClass('open');
  navlink.removeClass('open');
  navlink.attr('aria-expanded', 'false');
  headerClose();
  headerSubmenuClose();
  if ($(window).width() < breakPoint) {
    submenu.finish().animate({ opacity: 0 }, timeToEffect, 'linear', () => {
      submenu.hide().removeClass('open');
    });
  }
}

function submenuCloseAll() {
  $(navLink).removeClass('open');
  $(navItem).removeClass('open');
  $(submenuArrow).removeClass('open');
  $(submenuLink).attr('tabindex', '-1');
  $(submenuBtn).attr('tabindex', '-1');
  headerClose();
  headerSubmenuClose();
  if ($(window).width() < breakPoint) {
    $(submenuOuter).finish().animate({ opacity: 0 }, timeToEffect, 'linear', () => {
      $(submenuOuter).hide().removeClass('open');
    });
  }
}

$(document).on('click', hamburgerButton, (event) => {
  event.preventDefault();
  $(hamburger).toggleClass('open');
  if ($(hamburgerButton).hasClass('open')) {
    menuOpen();
    headerOpen();
  } else {
    menuClose();
    submenuCloseAll();
    submenuArrowClose(event);
    headerClose();
    headerSubmenuClose();
  }
});

function toggleSubmenu(event) {
  event.preventDefault();
  const current = $(event.target);
  const closest = $(current).closest(navItem);

  if (!closest.hasClass('open')) {
    submenuArrowOpen(event);
  } else {
    submenuArrowClose(event);
  }
}

function toggleDesktopSubmenu(event, eventType = 'simple') {
  const eventTarget = eventType === 'simple'
    ? event.target.classList.contains('open')
    : event.target.parentNode.parentNode.classList.contains('open');
  if (eventTarget) {
    submenuClose(event);
    headerClose();
  } else {
    submenuOpen(event);
    headerOpen();
  }
}

const navLinks = document.querySelectorAll(navLink);
navLinks.forEach((item) => {
  item.addEventListener('click', (event) => {
    const href = item.getAttribute('href');
    const { hasChildren } = item.dataset;

    if ($(window).width() > breakPoint) {
      if (((event.target.tagName === 'BUTTON') || (hasChildren === 'true'))
        && event.target.classList.contains('nav__link')
      ) {
        toggleDesktopSubmenu(event);
        event.preventDefault();
      }
      return;
    }

    if ((href && href.includes('#')) || (hasChildren === 'false')) return;

    toggleSubmenu(event);
  });
});

$(submenuArrow).on('click', (event) => {
  toggleSubmenu(event);
});

$(document).on('mouseenter', navList, () => {
  if ($(window).width() < breakPoint) {
    return;
  }
  $(navList).addClass('open');
});

$(document).on('mouseleave', navList, () => {
  if ($(window).width() < breakPoint) {
    return;
  }
  $(navList).removeClass('open');
});

$(document).on('mouseenter', navItem, (event) => {
  if ($(window).width() < breakPoint) {
    return;
  }
  if ($(event.target).hasClass('open')) {
    return;
  }
  if ($(navList).hasClass('open')) {
    submenuOpen(event);
    return;
  }
  submenuOpenFirst(event);
});

$(document).on('mouseleave', navItem, (event) => {
  if ($(window).width() < breakPoint) {
    return;
  }
  submenuClose(event);
  headerClose();
});

$(document).on('click', navItem, (event) => {
  if ($(window).width() < breakPoint || $(event.target).hasClass('open')
      || event.target.parentNode.parentNode.tagName.toLowerCase() !== 'button') {
    return;
  }
  toggleDesktopSubmenu(event, 'click');
});

$(window).on('resize', () => {
  const newWidth = $(window).width();
  const newHeight = $(window).height();

  if (newWidth < breakPoint) {
    if (newWidth !== width || newHeight !== height) {
      menuClose();
      submenuCloseAll();
      hamburgerClose();
      headerClose();
    }
  } else {
    menuOpen();
    $(submenuOuter).removeAttr('style');
  }

  height = newHeight;
  width = newWidth;
});

document.querySelectorAll('.nav__submenu').forEach((submenu) => {
  if (!submenu.querySelectorAll('.nav__submenu-preview--image').length) {
    submenu.querySelector('.nav__submenu-preview').classList.add('d-none');
  }

  submenu.querySelectorAll('.nav__submenu-link').forEach((item, key) => {
    item.addEventListener('mouseover', () => {
      submenu.querySelectorAll('.nav__submenu-preview--sub-image').forEach((preview) => {
        preview.classList.remove('d-block');
      });
      if (submenu.querySelectorAll('.nav__submenu-preview--sub-image')[key]) {
        submenu.querySelectorAll('.nav__submenu-preview--sub-image')[key].classList.add('d-block');
      }
    });
  });
});

window.document.querySelectorAll(navLink).forEach((item) => {
  if ($(window).width() < breakPoint) {
    return;
  }

  item.addEventListener('keydown', (event) => {
    const keyCode = event.keyCode || event.which;
    if (keyCode === 32 || (event.target.tagName === 'BUTTON' && keyCode === 13)) {
      event.preventDefault();
      toggleDesktopSubmenu(event);
    }
  });
  item.addEventListener('focus', () => {
    submenuCloseAll();
  });
});

const originalAltTexts = [];

const images = document.querySelectorAll('.nav__submenu img');

for (let i = 0; i < images.length; i++) {
  originalAltTexts[i] = images[i].alt;

  images[i].alt = '';

  images[i].addEventListener('load', function () {
    const index = Array.prototype.indexOf.call(images, this);

    this.alt = originalAltTexts[index];
  });
}
export default true;
